import { render, staticRenderFns } from "./setRoleMenu.vue?vue&type=template&id=6e7c3836&scoped=true"
import script from "./setRoleMenu.vue?vue&type=script&lang=js"
export * from "./setRoleMenu.vue?vue&type=script&lang=js"
import style0 from "./setRoleMenu.vue?vue&type=style&index=0&id=6e7c3836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c3836",
  null
  
)

export default component.exports